"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpSelectableButtonGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var classnames_1 = __importDefault(require("classnames"));
var Icon_1 = require("../../../Common/Icon/Icon");
var DpSelectableButtonGroup_styled_1 = require("./DpSelectableButtonGroup.styled");
var DpSelectableButtonGroup = function (props) {
    var buttons = props.buttons, changeHandler = props.changeHandler, icons = props.icons;
    var _a = (0, react_1.useState)(''), selected = _a[0], setSelected = _a[1];
    var getClassNames = function (label) {
        return (0, classnames_1.default)('btn', 'btn-primary', selected === label && 'active');
    };
    var handleChange = function (data) { return function (e) {
        if (selected === data) {
            setSelected('');
        }
        else {
            setSelected(data);
        }
        changeHandler(data);
    }; };
    var constructElement = function (elementProps, isIcon) {
        if (isIcon === void 0) { isIcon = false; }
        var label = elementProps.label, append = elementProps.append;
        return ((0, jsx_runtime_1.jsx)("button", { className: getClassNames(label), id: label, onClick: handleChange(label), children: !isIcon ? append ? "".concat(label, " (").concat(append, ")") : label : (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: label }) }, label));
    };
    var getElements = function (elementsProps, areIcons) {
        if (areIcons === void 0) { areIcons = false; }
        var elements = elementsProps.map(function (elementProps) { return constructElement(elementProps); });
        if (areIcons) {
            return elements;
        }
        elements.unshift(constructElement({ label: 'All' }));
        return elements;
    };
    return (0, jsx_runtime_1.jsx)(DpSelectableButtonGroup_styled_1.Styled, { className: "dp-selectable-button-group", children: getElements(buttons, icons) });
};
exports.DpSelectableButtonGroup = DpSelectableButtonGroup;
exports.default = exports.DpSelectableButtonGroup;
